/**
 * After a ripple / shift-connected persist, merge engine date changes into the
 * in-memory gantt overlay — and drop a drag-painted override when the engine
 * made no net change for the committed task (e.g. predecessor clamp).
 *
 * The dependency modal sets an optimistic override before Apply. If the schedule
 * engine runs against that same overlay, shift delta can be 0 and ripple can
 * clamp back to baseline with an empty `changes` list — leaving a lying paint
 * that looks saved until refresh. Callers should run the engine on baseline
 * dates; this helper still clears the overlay when the committed task is absent
 * from `changes`.
 */
export function applySchedulePersistToGanttOverrides(
  prev: Record<string, { startDate: Date; endDate: Date }>,
  changes: { id: string; startDate: Date; endDate: Date }[],
  committedTaskId: string,
): Record<string, { startDate: Date; endDate: Date }> {
  const next = { ...prev };
  for (const c of changes) {
    next[c.id] = { startDate: c.startDate, endDate: c.endDate };
  }
  if (!changes.some((c) => c.id === committedTaskId)) {
    delete next[committedTaskId];
  }
  return next;
}
